import React, { useEffect } from 'react'

// tremor 
import { Flex } from "@tremor/react";

// bootstrap
import { Button } from "react-bootstrap";

// custom components
import { CustomSpinner } from "_atoms";

// redux
import { useSelector, useDispatch } from "react-redux";
import { selectBookingType } from "_redux/slices/timeline/timeline-areas";
import { selectJob } from '_redux/slices/utils/menu-context';
import { getBookings, getDepartureBookings, selectDuplicatedCombinedBookings, selectDuplicatedCombinedRampBookings, setDuplicatedCombinedBookings, setDuplicatedCombinedRampBookings, resetDeleteBookingFlags, selectDeleteBookingStatus, deleteTimelineJob, selectDeleteTimelineJobStatus, selectDuplicatedDeparturesBookings, selectDuplicatedArrivalsBookings, setDuplicatedArrivalsBookings, setDuplicatedDepartureBookings, selectTimelineArrivalsBookingList, selectTimelineDeparturesBookingList, resetDeleteTimelineJobFlags } from '_redux/slices/timeline/timeline-data';
import { resetPostedBooking, patchBooking, selectPatchBookingStatus } from '_redux/slices/prm-bookings/bookings';

//styles
import { Colors, Spacing } from "_styles";
import { selectFirebaseInfo } from '_redux/slices/main-screen/user';
import { selectTimelineDate } from '_redux/slices/timeline/timeline-control';

// functions 
import { getDate } from "_utils/functions";
const DeleteBooking = ({ onClose }) => {

    //#region redux
    const dispatch = useDispatch();
    const job = useSelector(selectJob);
    const dbUser = useSelector(selectFirebaseInfo);                                       // logged in user

    const duplicatedCombinedBookings = useSelector(selectDuplicatedCombinedBookings);
    const duplicatedCombinedRampBookings = useSelector(selectDuplicatedCombinedRampBookings);
    const deleteTimelineJobStatus = useSelector(selectDeleteTimelineJobStatus);             // delete Timeline Job Status

    const timelineDate = useSelector(selectTimelineDate);                       // select timeline Date
    const bookingType = useSelector(selectBookingType);                        // select bookingType (departures,arrivals,all)
    const duplicatedDeparturesBookings = useSelector(selectDuplicatedDeparturesBookings);
    const duplicatedArrivalsBookings = useSelector(selectDuplicatedArrivalsBookings);
    const arrivalsBooking = useSelector(selectTimelineArrivalsBookingList);         // arrival booking list
    const departuresBooking = useSelector(selectTimelineDeparturesBookingList);     // departures booking list
    const patchBookingStatus = useSelector(selectPatchBookingStatus);                // patch booking status


    //#endregion

    //#region useEffect
    // reset delete bookings flags on first render
    useEffect(() => {
        dispatch(resetDeleteBookingFlags());
        dispatch(resetDeleteBookingFlags());
        dispatch(resetDeleteTimelineJobFlags());
    }, [])

    // reset delete bookings flags and get bookings
    useEffect(() => {
        if (deleteTimelineJobStatus === "succeeded" || patchBookingStatus === "succeeded") {
            if (bookingType?.includes("departures") || bookingType?.includes("all")) {
                handleGetDeparturesBookings();
            }
            if (bookingType?.includes("arrivals") || bookingType?.includes("all")) {
                handleGetArrivalsBookings();
            }
            dispatch(resetDeleteBookingFlags());
            dispatch(resetPostedBooking());
            dispatch(resetDeleteTimelineJobFlags());

            onClose();
        };
    }, [deleteTimelineJobStatus, patchBookingStatus]);
    //#endregion

    //#region functions
    const confirmDelete = () => {
        // departure or arrival
        const bookingType = dbUser.details.authority === job?.flightConfirmationDetails?.origin ? "outbound" : "inbound";
        // check if it is combinedRampBooking 
        if (job?.combinedRampBooking) {
            let tempRampBookings = Array.isFullArray(duplicatedCombinedRampBookings) ? [...duplicatedCombinedRampBookings] : [];
            // filter the tempRampBookings from the selected job that matches it's id
            tempRampBookings = tempRampBookings?.filter(item => item?.doc?._id !== job?._id);
            // reset DuplicatedCombinedRampBookings with the new filtered array 
            if (tempRampBookings) dispatch(setDuplicatedCombinedRampBookings(tempRampBookings));
            onClose();

        } else if (job?.combinedBooking) {
            // check if it is combinedBooking 
            let tempCombinedBookings = Array.isFullArray(duplicatedCombinedBookings) ? [...duplicatedCombinedBookings] : [];
            // filter the tempCombinedBookings from the selected job that matches it's id
            tempCombinedBookings = tempCombinedBookings?.filter(item => item?.doc?._id !== job?._id);
            // reset DuplicatedCombinedBookings with the new filtered array 
            if (tempCombinedBookings) dispatch(setDuplicatedCombinedBookings(tempCombinedBookings));
            onClose();

        } else if (job?.duplicateVersion || job?.originalBookingDoc?.duplicateVersion) {
            // arrival if there is flightBooking else departures
            if (job?.flightBooking) {
                // get the original booking for the duplicate
                let originalArrival = arrivalsBooking?.find((arrival) => arrival?.doc?._id === job?.originalBookingId?.split("-part")?.[0]);
                if (originalArrival?.doc?._id) {
                    // update the original booking duplicateCount when deleting a duplicate 
                    let tempOriginal = {
                        ...originalArrival?.doc
                    };
                    if (tempOriginal?.duplicateCount === 1) delete tempOriginal?.duplicateCount;
                    else if (tempOriginal?.duplicateCount) tempOriginal["duplicateCount"] = tempOriginal?.duplicateCount - 1;
                    dispatch(patchBooking({ ...tempOriginal }));
                }
                let tempDuplicatedArrivals = Array.isFullArray(duplicatedArrivalsBookings) ? [...duplicatedArrivalsBookings] : [];

                // filter the tempDuplicatedArrivals from the selected job that matches it's id
                tempDuplicatedArrivals = tempDuplicatedArrivals?.filter((duplicate) => duplicate?.doc?._id !== job?.originalBookingId);
                dispatch(setDuplicatedArrivalsBookings(tempDuplicatedArrivals));
            } else {
                // get the original booking for the duplicate
                let originalDeparture = departuresBooking?.find((departure) => departure?.doc?._id === job?._id?.split("-part")?.[0]);
                if (originalDeparture?.doc?._id) {
                    // update the original booking duplicateCount when deleting a duplicate 
                    let tempOriginal = {
                        ...originalDeparture?.doc
                    };
                    if (tempOriginal?.duplicateCount === 1) delete tempOriginal?.duplicateCount;
                    else if (tempOriginal?.duplicateCount) tempOriginal["duplicateCount"] = tempOriginal?.duplicateCount - 1;
                    dispatch(patchBooking({ ...tempOriginal }));

                }
                let tempDuplicatedDepartures = Array.isFullArray(duplicatedDeparturesBookings) ? [...duplicatedDeparturesBookings] : [];

                // filter the tempDuplicatedArrivals from the selected job that matches it's id
                tempDuplicatedDepartures = tempDuplicatedDepartures?.filter((duplicate) => duplicate?.doc?._id !== job?._id);

                dispatch(setDuplicatedDepartureBookings(tempDuplicatedDepartures));
            }
        } else {
            // check if arrival
            if (job?.flightBooking && job?.originalBookingId) {
                dispatch(deleteTimelineJob(job?.originalBookingId));

            } else if (job?.isEstimatedBooking && job?.originalBookingId) {
                dispatch(deleteTimelineJob(job?.originalBookingId));

            } else {
                dispatch(deleteTimelineJob(job?._id));

            }
        }


    }

    // get arrivals bookings
    const handleGetArrivalsBookings = () => {
        const date = getDate(timelineDate);

        dispatch(
            getBookings({
                iata: dbUser.details.authority,
                type: "inbound",
                start: date,
                end: date,
                skip: 0,
                limit: 1000,
                source: "none",
            })
        );
    };

    // get departures bookings
    const handleGetDeparturesBookings = () => {
        const date = getDate(timelineDate);

        dispatch(
            getDepartureBookings({
                iata: dbUser.details.authority,
                type: "outbound",
                start: date,
                end: date,
                skip: 0,
                limit: 1000,
                source: "none",
            })
        );
    };
    //#endregion

    return (
        <div>
            {/* action buttons */}
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <Button
                    variant={"outline-danger"}
                    onClick={confirmDelete}
                    style={{ width: 200 }}
                    loading={deleteTimelineJobStatus === "loading" || patchBookingStatus === "loading"}
                >{(deleteTimelineJobStatus === "loading" || patchBookingStatus === "loading") ? <CustomSpinner /> : "Delete PRM Booking"}</Button>
            </div>

        </div>
    )
}

export default DeleteBooking
